import React from 'react'
import './Footer.css'
import Wave from '../../img/wave.png'
import Insta from '@iconscout/react-unicons/icons/uil-instagram'
import Github from '@iconscout/react-unicons/icons/uil-github'
import Linkdin from '@iconscout/react-unicons/icons/uil-linkedin'

const Footer = () => {
  return (
    <div className="footer">
        <img src={Wave} alt="" style={{width:'100%'}}/>
        <div className="f-content">
            <span>ratikantp71@gmail.com</span>
            <div className="f-icons">
              <a href='https://www.linkedin.com/in/ratikant-patil-9b5521218/'>
                <Linkdin color='white' size='3rem'/>
                </a>
              <a href='https://www.instagram.com/patil_ratikant_01/?next=%2F'>
                <Insta color='white' size='3rem'/>
              </a>
              <a href='https://github.com/RatikantPatil01'>
                <Github color='white' size='3rem'/>
              </a>
            </div>
        </div>
    </div>
  )
}

export default Footer